export const typeOptions = ['PATIENT', 'DOCTOR'];
export const sexOptions = ['FEMALE', 'MALE', 'NB_INTERSEX'];
export const genderOptions = [
    'WOMAN',
    'MAN',
    'TRANS_WOMAN',
    'TRANS_MAN',
    'NONBINARY',
    'AGENDER',
    'GENDERQUEER',
    'PREFER_NO_ANSWER',
    'NOT_LISTED'
];
